import * as React from 'react';

export function SignedDocumentIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z' />
			<path d='M14 2v5a1 1 0 0 0 1 1h5' />
			<path d='M8 12h3' />
			<path d='M7.5 18.2c1.4-3.1 2.3-4.4 3-4.1.8.4-.7 4.2.2 4.7.7.4 1.6-1.2 2.5-1.2.8 0 .6 1.3 1.4 1.3.7 0 1.4-.9 1.9-.9' />
		</svg>
	);
}
